import React from "react";
import NoDataImg from "../../assets/images/no-data.svg";
import Icon from "../Icon";

const NoData = ({ text }) => {
  return (
    <div className="no-data-wrap">
      <div className="img-wrap">
        <Icon alt="no-data" src={NoDataImg}></Icon>
        <span className="no-data-text">{text || "데이터가 없습니다."}</span>
      </div>
    </div>
  );
};

export default NoData;
